<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useLoginSection, type LoginSectionProps } from './useLoginSection'
import { useStaticAsset } from '@/composables/useStaticAsset'

const asset = useStaticAsset()

const props = defineProps<LoginSectionProps>()

const emit = defineEmits<{
  (e: 'change', section: string): void
  (e: 'update:shared-data', data: Record<string, unknown>): void
}>()

const { changeSection, setDataItem } = useLoginSection(props, emit)

const role = ref(-1)
const error = ref('')

watch(role, () => {
  error.value = ''
})

onMounted(() => {
  const queryRoleMapping: Record<string, number> = { parent: 0, teacher: 1 }
  const predefinedRole = props.sharedData.role ?? queryRoleMapping[props.query.get('type') || '']

  if (props.query.get('purpose') === 'smartbook') {
    setDataItem('role', 0)
    openNextSection()
    return
  }

  if (props.query.get('purpose') === 'seminar') {
    setDataItem('role', 1)
    openNextSection()
    return
  }

  if (predefinedRole !== undefined) {
    setDataItem('role', predefinedRole)
    openNextSection()
  }
})

function submit() {
  if (![0, 1].includes(role.value)) {
    error.value = 'Выберите аккаунт'
    return
  }
  setDataItem('role', role.value)
  openNextSection()
}

function openNextSection() {
  if (props.query.get('create_step') !== 'true') {
    changeSection(props.LoginSection.SignupProfileForm)
  } else {
    changeSection(props.LoginSection.SignupForm)
  }
}
</script>

<template>
  <div class="signup-role">
    <h1 class="text-h3 mb-3">Какой аккаунт вы хотели бы завести?</h1>

    <v-card-button class="mb-2" hide-arrow @click="role = 0">
      <template #icon>
        <div class="signup-role__icon signup-role__icon_parent">
          <img :src="asset('img/team-fill.svg')" />
        </div>
      </template>

      <div class="d-flex align-center">
        Я — Родитель
        <div class="flex-spacer"></div>
        <v-icon v-show="role === 0" size="32">checkmark</v-icon>
      </div>
    </v-card-button>

    <v-card-button hide-arrow @click="role = 1">
      <template #icon>
        <div class="signup-role__icon signup-role__icon_teacher">
          <img :src="asset('img/student-cap-orange.svg')" />
        </div>
      </template>

      <div class="d-flex align-center">
        Я — Учитель (+ Кабинет родителя)
        <div class="flex-spacer"></div>
        <v-icon v-show="role === 1" size="32">checkmark</v-icon>
      </div>
    </v-card-button>

    <div v-if="error" class="red-text mt-2" v-text="error"></div>

    <v-button class="mt-6" mode="primary large block" @click="submit"> Выбрать </v-button>
  </div>
</template>

<style lang="scss">
.signup-role {
  display: flex;
  flex-direction: column;

  &__icon {
    border-radius: 999px;
    width: 48px;
    height: 48px;
    padding: 12px;

    &_parent {
      background: $lightenBlue;
    }

    &_teacher {
      background: $lightenOrange;
    }
  }
}
</style>
